const yup = require('yup')
const { requiredFields, labelify } = require('./helpers')

const types = ['Calendar', 'Newsletter', 'Flyer', 'LFP']
const sizingTypes = ['LTR', 'TAB', 'LFP']
const providers = ['activity-connection', 'cloud-printer']
const shownOnOptions = ['events', 'publications', 'all']

const shape = labelify({
  productId: yup.number().required(),
  name: yup.string().default(''),
  sku: yup.string().required(),
  enabled: yup.boolean(),
  type: yup.string().oneOf(types).default('Calendar'),
  provider: yup.string().oneOf(providers).default('cloud-printer'),
  shownOn: yup.string().oneOf(shownOnOptions).default('all'),
  data: yup.object().shape({
    id: yup.number(),
    productName: yup.string(),
    shortDescription: yup.string().nullable(true).max(500),
    description: yup.string().nullable(true).max(1000),
    sku: yup.string().required('SKU is required.'),
    sizingType: yup.string().required('Sizing type is required.').oneOf(sizingTypes),
    productType: yup.string().oneOf(types).required('Product Type is required.'),
    productCategory: yup.string().required(),
    duplex: yup.boolean().default(false),
    staple: yup.boolean().default(false),
    flat: yup.boolean().default(false),
    customSize: yup.boolean().default(false),
    longEdgeMinDimension: yup.number(),
    longEdgeMaxDimension: yup.number(),
    shortEdgeMinDimension: yup.number(),
    shortEdgeMaxDimension: yup.number(),
  }),
  price: yup.object().shape({
    current: yup.number().nullable(),
    quiltt: yup.number().nullable(),
  }),
  product: yup.object().shape({
    name: yup.string(),
    reference: yup.string(),
    material: yup.string(),
    quantities: yup.array().of(yup.number()).default([]),
    orderableQuantities: yup.mixed(),
    totalPageOptionEnabled: yup.boolean().default(false),
  }),
  size: yup.object().when('provider', {
    is: 'cloud-printer',
    then: yup.object().shape({
      current: yup
        .object()
        .shape({
          width: yup.number().required('Width (size.current.width) is required.'),
          height: yup.number().required('Height (size.current.height) is required.'),
        })
        .required('Size (size.current) is required for Cloud Printer products.'),
    }),
    otherwise: yup.object().shape({
      current: yup.object().shape({ width: yup.number(), height: yup.number() }),
    }),
  }),
  numberOfPages: yup.number(),
  createdAt: yup.date(),
  updatedAt: yup.date(),
  createdBy: yup.mixed(),
  updatedBy: yup.mixed(),
})

const printOrderCatalogSchemaPartial = yup.object().shape(shape)
const printOrderCatalogSchema = printOrderCatalogSchemaPartial.shape(requiredFields(['name'])(shape))

module.exports = { printOrderCatalogSchema, printOrderCatalogSchemaPartial }
